export default __webpack_public_path__ + "static/media/bdswissGlobalReal03_downloadMT4.cda6855b.png";